import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SideBarClickService {

  value = new BehaviorSubject<boolean>(false);

  constructor() { }

  setValue(inputValue) {
    this.value.next(inputValue);
  }

  getValue(): Observable<boolean> {
    return this.value.asObservable();
  }
}
